@if (parameterService.coupon_cashing_list.length > 0) {
<div class="list-group-item">
  <div class="overview-wrapper">
    <span>Betrag</span>
    <span>
      {{ parameterService.payment?.amount | currency : 'EUR' : 'symbol' }}
    </span>
  </div>
</div>
<div
  class="list-group-item"
  *ngFor="let cp of parameterService.coupon_cashing_list"
>
  <div class="overview-wrapper">
    <span>
      abzgl. Gutschein / Rabatt<br />
      <small>Code {{ cp.coupon_code }}</small>
    </span>
    <span>
      {{ cp.amount * -1 | currency : 'EUR' : 'symbol' }}
    </span>
  </div>
</div>
<div class="list-group-item">
  <div class="overview-wrapper">
    <span>Restbetrag</span>
    <span>
      {{ parameterService.getOpenAmount() | currency : 'EUR' : 'symbol' }}
    </span>
  </div>
</div>
}
